function _regeneratorValues(e) { if (null != e) { var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0; if (t) return t.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } }; } throw new TypeError(_typeof(e) + " is not iterable"); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MyPendingsService from '@/apps/data-platform/services/tables_views/my_pendings_service';
import UseCasesService from '@/apps/attributes/services/use_cases_service';
import CustomerInsightsService from '@/apps/customer-insigths/services/customer_insights_service';
import UserSecurityService from '@/apps/data-platform/services/security/user_security_service';
import DialogConfirmationComponent from '@/components/DialogConfirmationComponent.vue';
import tasks from '@/js/tasks';
export default {
  name: 'MigrationsPage',
  components: {
    DialogConfirmationComponent: DialogConfirmationComponent
  },
  data: function data() {
    return {
      activeTab: 'email',
      migrations: [],
      loading: false,
      results: null,
      expandedEndpoint: null,
      rawResponses: {},
      availableEndpoints: [{
        key: 'data_platform',
        name: 'Migración de accesos en data platform',
        enabled: true,
        payloadFormat: 'legacy'
      }, {
        key: 'attributes',
        name: 'Migración de usuarios atributos',
        enabled: true,
        payloadFormat: 'legacy'
      }, {
        key: 'customer_insights',
        name: 'Migración de applicant customer insights',
        enabled: true,
        payloadFormat: 'domain'
      }, {
        key: 'security_roles',
        name: 'Migración de roles de seguridad',
        enabled: true,
        payloadFormat: 'domain'
      }]
    };
  },
  computed: {
    headers: function headers() {
      return [{
        text: this.$t('migrations.old_email'),
        value: 'correo_antiguo',
        sortable: false
      }, {
        text: this.$t('migrations.new_email'),
        value: 'correo_nuevo',
        sortable: false
      }, {
        text: this.$t('migrations.valid'),
        value: 'valid',
        sortable: false,
        width: '80px'
      }, {
        text: this.$t('migrations.actions'),
        value: 'actions',
        sortable: false,
        width: '80px'
      }];
    },
    resultHeaders: function resultHeaders() {
      return [{
        text: this.$t('migrations.endpoint'),
        value: 'endpoint',
        sortable: false,
        width: '120px'
      }, {
        text: this.$t('migrations.old_email'),
        value: 'correo_antiguo',
        sortable: false
      }, {
        text: this.$t('migrations.new_email'),
        value: 'correo_nuevo',
        sortable: false
      }, {
        text: this.$t('migrations.status'),
        value: 'status',
        sortable: false,
        width: '100px'
      }, {
        text: this.$t('migrations.message'),
        value: 'message',
        sortable: false
      }];
    },
    endpointHeaders: function endpointHeaders() {
      return [{
        text: this.$t('migrations.endpoint'),
        value: 'name',
        sortable: false
      }, {
        text: this.$t('migrations.status'),
        value: 'status',
        sortable: false,
        width: '100px'
      }, {
        text: this.$t('migrations.successful'),
        value: 'successful',
        sortable: false,
        width: '100px'
      }, {
        text: this.$t('migrations.failed'),
        value: 'failed',
        sortable: false,
        width: '100px'
      }, {
        text: this.$t('migrations.message'),
        value: 'error',
        sortable: false
      }, {
        text: 'Debug',
        value: 'raw',
        sortable: false,
        width: '120px'
      }];
    },
    selectedEndpoints: function selectedEndpoints() {
      return this.availableEndpoints.filter(function (ep) {
        return ep.enabled;
      });
    },
    allEndpointsSelected: function allEndpointsSelected() {
      return this.availableEndpoints.every(function (ep) {
        return ep.enabled;
      });
    }
  },
  methods: {
    addRow: function addRow() {
      if (this.migrations.length >= 10) {
        tasks.toast.error(this.$t('migrations.max_rows_reached'));
        return;
      }
      this.migrations.push({
        correo_antiguo: '',
        correo_nuevo: '',
        valid: null
      });
    },
    removeRow: function removeRow(index) {
      this.migrations.splice(index, 1);
    },
    validateRow: function validateRow(index) {
      var row = this.migrations[index];
      var emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
      if (row.correo_antiguo && row.correo_nuevo) {
        row.valid = emailRegex.test(row.correo_antiguo) && emailRegex.test(row.correo_nuevo);
      } else {
        row.valid = null;
      }
      this.$set(this.migrations, index, row);
    },
    triggerFileInput: function triggerFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileUpload: function handleFileUpload(event) {
      var _this = this;
      var file = event.target.files[0];
      if (!file) return;
      var reader = new FileReader();
      reader.onload = function (e) {
        var csvData = e.target.result;
        _this.parseCSV(csvData);
      };
      reader.readAsText(file, 'ISO-8859-1');
      event.target.value = '';
    },
    parseCSV: function parseCSV(csvData) {
      var lines = csvData.split('\n');
      var headers = lines[0].toLowerCase().trim().split(/[,;]/);
      var oldEmailIndex = headers.findIndex(function (h) {
        return h.includes('antiguo') || h.includes('old');
      });
      var newEmailIndex = headers.findIndex(function (h) {
        return h.includes('nuevo') || h.includes('new');
      });
      if (oldEmailIndex === -1 || newEmailIndex === -1) {
        tasks.toast.error(this.$t('migrations.invalid_csv_format'));
        return;
      }
      this.migrations = [];
      for (var i = 1; i < lines.length; i++) {
        var line = lines[i].trim();
        if (!line) continue;
        if (this.migrations.length >= 10) {
          tasks.toast.warning(this.$t('migrations.max_rows_reached'));
          break;
        }
        var values = line.split(/[,;]/);
        if (values.length > Math.max(oldEmailIndex, newEmailIndex)) {
          var oldEmail = values[oldEmailIndex] ? values[oldEmailIndex].trim() : '';
          var newEmail = values[newEmailIndex] ? values[newEmailIndex].trim() : '';
          if (oldEmail && newEmail) {
            this.migrations.push({
              correo_antiguo: oldEmail,
              correo_nuevo: newEmail,
              valid: null
            });
            this.validateRow(this.migrations.length - 1);
          }
        }
      }
      if (this.migrations.length > 0) {
        tasks.toast.success(this.$t('migrations.csv_loaded', {
          count: this.migrations.length
        }));
      }
    },
    toggleAllEndpoints: function toggleAllEndpoints() {
      var newState = !this.allEndpointsSelected;
      this.availableEndpoints.forEach(function (ep) {
        ep.enabled = newState;
      });
    },
    buildPayload: function buildPayload(format) {
      var filtered = this.migrations.filter(function (m) {
        return m.correo_antiguo && m.correo_nuevo;
      });
      if (format === 'legacy') {
        return {
          migrations: filtered.map(function (m) {
            return {
              correo_antiguo: m.correo_antiguo,
              correo_nuevo: m.correo_nuevo
            };
          }),
          dry_run: false
        };
      }
      if (format === 'domain') {
        return {
          migrations: filtered.map(function (m) {
            return {
              old_email: m.correo_antiguo,
              new_email: m.correo_nuevo
            };
          })
        };
      }
      return {
        migrations: []
      };
    },
    getEndpointFn: function getEndpointFn(key, payload) {
      var fns = {
        'data_platform': function data_platform() {
          return MyPendingsService.migrateEmailsBatch(payload);
        },
        'attributes': function attributes() {
          return UseCasesService.migrateUserEmail(payload);
        },
        'customer_insights': function customer_insights() {
          return CustomerInsightsService.migrateApplicant(payload);
        },
        'security_roles': function security_roles() {
          return UserSecurityService.migrateRoles(payload);
        }
      };
      return fns[key];
    },
    normalizeResponse: function normalizeResponse(response) {
      if (response && _typeof(response) === 'object') {
        // Caso 1: { success: true/false, data: { successful, failed, details } }
        if ('success' in response) {
          var data = response.data || {};
          return {
            success: response.success,
            successful: data.successful || 0,
            failed: data.failed || 0,
            details: data.details || []
          };
        }
        // Caso 2: Respuesta directamente con successful/failed
        if ('successful' in response || 'failed' in response) {
          return {
            success: true,
            successful: response.successful || 0,
            failed: response.failed || 0,
            details: response.details || []
          };
        }
        // Caso 3: Formato desconocido - se trata como éxito sin datos estructurados
        return {
          success: true,
          successful: 0,
          failed: 0,
          details: []
        };
      }
      return {
        success: false,
        successful: 0,
        failed: 0,
        details: []
      };
    },
    toggleRawResponse: function toggleRawResponse(name) {
      this.expandedEndpoint = this.expandedEndpoint === name ? null : name;
    },
    formatJSON: function formatJSON(obj) {
      try {
        return JSON.stringify(obj, null, 2);
      } catch (e) {
        return String(obj);
      }
    },
    copyRawResponse: function copyRawResponse() {
      if (this.expandedEndpoint && this.rawResponses[this.expandedEndpoint]) {
        var text = this.formatJSON(this.rawResponses[this.expandedEndpoint]);
        navigator.clipboard.writeText(text).then(function () {
          tasks.toast.success('JSON copiado al portapapeles');
        }).catch(function () {
          tasks.toast.error('No se pudo copiar');
        });
      }
    },
    executeMigration: function executeMigration() {
      var invalidRows = this.migrations.filter(function (m) {
        return m.valid === false;
      });
      if (invalidRows.length > 0) {
        tasks.toast.error(this.$t('migrations.invalid_rows'));
        return;
      }
      var validMigrations = this.migrations.filter(function (m) {
        return m.valid === true || m.correo_antiguo && m.correo_nuevo;
      });
      if (validMigrations.length === 0) {
        tasks.toast.error(this.$t('migrations.no_valid_rows'));
        return;
      }
      this.$refs.dialogConfirmation.onOpen();
    },
    onConfirmMigration: function () {
      var _onConfirmMigration = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(confirm) {
        var _this2 = this;
        var _iterator, _step, _loop, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this.$refs.dialogConfirmation.onClose();
              if (confirm) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              this.loading = true;
              this.expandedEndpoint = null;
              this.rawResponses = {};
              this.results = {
                successful: 0,
                failed: 0,
                details: [],
                endpointSummary: []
              };
              _iterator = _createForOfIteratorHelper(this.selectedEndpoints);
              _context2.p = 2;
              _loop = /*#__PURE__*/_regenerator().m(function _loop() {
                var endpoint, payload, endpointFn, endpointResult, response, normalized, _this2$results$detail, details, _t;
                return _regenerator().w(function (_context) {
                  while (1) switch (_context.p = _context.n) {
                    case 0:
                      endpoint = _step.value;
                      payload = _this2.buildPayload(endpoint.payloadFormat);
                      endpointFn = _this2.getEndpointFn(endpoint.key, payload);
                      endpointResult = {
                        name: endpoint.name,
                        status: 'pending',
                        successful: 0,
                        failed: 0,
                        error: null
                      };
                      _context.p = 1;
                      _context.n = 2;
                      return endpointFn();
                    case 2:
                      response = _context.v;
                      // Guardar respuesta raw para debug
                      _this2.$set(_this2.rawResponses, endpoint.name, response);

                      // Normalizar respuesta
                      normalized = _this2.normalizeResponse(response);
                      if (normalized.success) {
                        details = (normalized.details || []).map(function (detail) {
                          return _objectSpread(_objectSpread({}, detail), {}, {
                            endpoint: endpoint.name
                          });
                        });
                        _this2.results.successful += normalized.successful;
                        _this2.results.failed += normalized.failed;
                        (_this2$results$detail = _this2.results.details).push.apply(_this2$results$detail, _toConsumableArray(details));
                        endpointResult.status = 'success';
                        endpointResult.successful = normalized.successful;
                        endpointResult.failed = normalized.failed;
                      } else {
                        endpointResult.status = 'error';
                        endpointResult.error = response.message || _this2.$t('migrations.unknown_error');
                      }
                      _context.n = 4;
                      break;
                    case 3:
                      _context.p = 3;
                      _t = _context.v;
                      console.error("Error en ".concat(endpoint.name, ":"), _t);
                      _this2.$set(_this2.rawResponses, endpoint.name, {
                        error: _t.message,
                        stack: _t.stack
                      });
                      endpointResult.status = 'error';
                      endpointResult.error = _t.message || _this2.$t('migrations.unknown_error');
                      tasks.toast.error(_this2.$t('migrations.endpoint_error', {
                        name: endpoint.name
                      }));
                    case 4:
                      _context.p = 4;
                      _this2.results.endpointSummary.push(endpointResult);
                      return _context.f(4);
                    case 5:
                      return _context.a(2);
                  }
                }, _loop, null, [[1, 3, 4, 5]]);
              });
              _iterator.s();
            case 3:
              if ((_step = _iterator.n()).done) {
                _context2.n = 5;
                break;
              }
              return _context2.d(_regeneratorValues(_loop()), 4);
            case 4:
              _context2.n = 3;
              break;
            case 5:
              _context2.n = 7;
              break;
            case 6:
              _context2.p = 6;
              _t2 = _context2.v;
              _iterator.e(_t2);
            case 7:
              _context2.p = 7;
              _iterator.f();
              return _context2.f(7);
            case 8:
              if (this.results.failed === 0) {
                tasks.toast.success(this.$t('migrations.migration_complete'));
              } else {
                tasks.toast.warning(this.$t('migrations.migration_partial'));
              }
              this.loading = false;
            case 9:
              return _context2.a(2);
          }
        }, _callee, this, [[2, 6, 7, 8]]);
      }));
      function onConfirmMigration(_x) {
        return _onConfirmMigration.apply(this, arguments);
      }
      return onConfirmMigration;
    }()
  }
};